<template>
  <base-table :data="data">
    <el-table-column
      prop="location"
      :label="$t('sections.locationTariffs.table.location')"
    />
    <el-table-column
      prop="connectorId"
      :label="$t('sections.locationTariffs.table.connectorId')"
    />
    <el-table-column
      prop="type"
      :label="$t('sections.locationTariffs.table.type')"
    />
    <el-table-column
      prop="valueKwh"
      :label="$t('sections.locationTariffs.table.valueKwh')"
    />
    <el-table-column
      prop="valueMin"
      :label="$t('sections.locationTariffs.table.valueMin')"
    />
    <el-table-column
      prop="minInterval"
      :label="$t('sections.locationTariffs.table.minInterval')"
    />
    <el-table-column fixed="right" width="60" v-if="tariffsPermissions.read">
      <template slot-scope="props">
        <div class="d-flex justify-content-center">
          <el-dropdown trigger="click">
            <div class="outline-icon-button">
              <font-awesome-icon icon="fa-regular fa-ellipsis-vertical" />
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <router-link
                  :to="{
                    name: 'Location Tariff Detail',
                    params: {
                      id: props.row.id,
                      locationTariff: props.row,
                    },
                  }"
                >
                  {{ $t("sections.locationTariffs.options")[0] }}
                </router-link>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
    </el-table-column>
  </base-table>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'LocationTariffsListTable',
  data() {
    return {
      data: [
        {
          id: 'OER-0023',
          location: 'location',
          connectorId: 'connectorId',
          type: 'Type',
          valueKwh: 'Value kWh',
          valueMin: 'Value Min',
          minInterval: 'Min. Interval',
          city: 'City',
          partyId: 'Party Id',
        },
      ],
    };
  },
  computed: {
    ...mapGetters(['getTariffs', 'getPagePermissions']),
    tariffsPermissions() {
      return this.getPagePermissions('Tariffs Manager - Tariffs');
    },
  },
};
</script>
<style lang="scss" scoped></style>
